module.exports = __webpack_public_path__ + "static/img/rank-plain.03de775d.svg";